import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

export const processError = (error) => {
  if ((error instanceof Error && error.message ) || (error && error.message)) {
    toast.error(error.message)
  }
  console.log('-- Processing ERROR --', error)
}
